module.exports = __webpack_public_path__ + "img/graph_1.48352fb0.svg";